// extracted by mini-css-extract-plugin
export var content = "_pp-1";
export var noScroll = "_pp-3";
export var paper = "_pp-0";
export var scrollable = "_pp-2";